import React, { FC } from 'react';
import cx from 'classnames';

import dashToCamelCase from 'utils/dashToCamelCase';

import styles from './text.module.scss';

type ITextCategory = 'h1' | 'h2' | 'h3-sans' | 'h3-serif' | 'h4' | 'h5' | 'p' | 'caption';
type ITagMap = { [key in ITextCategory]: keyof JSX.IntrinsicElements; };

const tagMap: ITagMap = {
  h1: 'h1',
  h2: 'h2',
  'h3-sans': 'h3',
  'h3-serif': 'h3',
  h4: 'h4',
  h5: 'h5',
  p: 'p',
  caption: 'div',
};

interface IProps {
  className?: string;
  category?: ITextCategory;
  noTag?: boolean;
}

const Text: FC<IProps> = ({
  children,
  className,
  category,
  noTag,
}) => {
  const Tag: keyof JSX.IntrinsicElements = noTag ? 'div' : (tagMap[category || 'p'] ?? 'p');
  return (
    <Tag className={cx(styles[dashToCamelCase(category || 'p')], className)}>{children}</Tag>
  );
};

export default Text;
